export default __webpack_public_path__ + "static/media/st-joseph-higher-secondary.4552fb64.png";